export class GameConstants {
}
// version: v0.month.day.hour
GameConstants.VERSION = "v0.9.30.11";
GameConstants.RELOAD_BASE_TICKS = 10;
GameConstants.BULLET_SPEED = .8; // in cells / tick
GameConstants.MORTAR_SPEED = .45;
GameConstants.INITIAL_TICKS_WAVE = 4;
GameConstants.ENEMY_SOLDIER = "soldier";
GameConstants.ENEMY_RUNNER = "runner";
GameConstants.ENEMY_HEALER = "healer";
GameConstants.ENEMY_BLOB = "blob";
GameConstants.ENEMY_FLIER = "flier";
GameConstants.TURRET_PROJECTILE = "projectile";
GameConstants.TURRET_LASER = "laser";
GameConstants.TURRET_LAUNCH = "launch";
GameConstants.TURRET_GLUE = "glue";
GameConstants.ATTRIBUTE_DAMAGE = "damage";
GameConstants.ATTRIBUTE_RELOAD = "reload";
GameConstants.ATTRIBUTE_RANGE = "range";
GameConstants.ATTRIBUTE_EXPLOSION_RANGE = "explosionRange";
GameConstants.ATTRIBUTE_INTENSITY = "intensity";
GameConstants.ATTRIBUTE_DURATION = "duration";
GameConstants.ATTRIBUTE_PRICE_IMPROVEMENT = "priceImprovement";
GameConstants.ATTRIBUTE_PRICE_UPGRADE = "priceUpgrade";
GameConstants.ATTRIBUTE_TELEPORT_DISTANCE = "teleportDistance";
GameConstants.STRATEGY_SHOOT_FIRST = "first";
GameConstants.STRATEGY_SHOOT_LAST = "last";
GameConstants.STRATEGY_SHOOT_CLOSEST = "closest";
GameConstants.STRATEGY_SHOOT_WEAKEST = "weakest";
GameConstants.STRATEGY_SHOOT_STRONGEST = "strongest";
GameConstants.STRATEGIES_ARRAY = [
    GameConstants.STRATEGY_SHOOT_FIRST,
    GameConstants.STRATEGY_SHOOT_LAST,
    GameConstants.STRATEGY_SHOOT_CLOSEST,
    GameConstants.STRATEGY_SHOOT_WEAKEST,
    GameConstants.STRATEGY_SHOOT_STRONGEST
];
GameConstants.HEALER_HEALING_TICKS = 200;
GameConstants.HEALER_STOP_TICKS = 5;
GameConstants.HEALER_HEALING_RADIUS = 2;
GameConstants.DIFFICULTY_MODIFIER = 8e-4;
GameConstants.DIFFICULTY_EXPONENT = 1.9;
GameConstants.DIFFICULTY_LINEAR = 20;
GameConstants.MIN_HEALTH_MODIFIER = 0.5;
GameConstants.REWARD_MODIFIER = 0.4;
GameConstants.REWARD_EXPONENT = 0.5;
GameConstants.MIN_REWARD_MODIFIER = 1;
GameConstants.EARLY_BONUS_MODIFIER = 3;
GameConstants.EARLY_BONUS_EXPONENT = 0.6;
GameConstants.WEAK_AGAINST_DAMAGE_MODIFIER = 3.0;
GameConstants.STRONG_AGAINST_DAMAGE_MODIFIER = 0.33;
// error types
GameConstants.ERROR_VERSION_MISMATCH = "E001";
GameConstants.ERROR_NO_GAME_OVER = "E002";
GameConstants.ERROR_TICKS = "E003";
GameConstants.ERROR_ACTION_ARRAY = "E004";
GameConstants.ERROR_ACTION_TYPE = "E005";
GameConstants.ERROR_ACTION_VALUE = "E006";
GameConstants.ERROR_TURRET = "E007";
GameConstants.ERROR_CREDITS = "E008";
GameConstants.ERROR_NEXT_WAVE = "E009";
GameConstants.ERROR_ADD_TURRET_POSITION = "E010";
GameConstants.ERROR_ADD_TURRET_NAME = "E011";
GameConstants.ERROR_UPGRADE = "E012";
GameConstants.ERROR_LEVEL_UP = "E013";
// action types
GameConstants.ACTION_TYPE_NEXT_WAVE = "next wave";
GameConstants.ACTION_TYPE_ADD_TURRET = "add turret";
GameConstants.ACTION_TYPE_SELL_TURRET = "sell turret";
GameConstants.ACTION_TYPE_UPGRADE_TURRET = "upgrade turret";
GameConstants.ACTION_TYPE_LEVEL_UP_TURRET = "level up turret";
GameConstants.ACTION_TYPE_CHANGE_STRATEGY_TURRET = "change strategy turret";
GameConstants.ACTION_TYPE_CHANGE_FIXED_TARGET_TURRET = "change fixed target turret";
//# sourceMappingURL=data:application/json;base64,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